import { FETCH_BATTERY_SOH } from "../../actions/types";

const INITIAL_STATE = {
  timestamp: null,
  id: null,
  value: null
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_BATTERY_SOH:
      return payload;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/helpers/battery_soh.js